import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import publicApi from '../services/public.api'
import { useCart } from '../context/CartContext'

const TopVendorsOne = () => {
    const [packs, setPacks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [addingPackId, setAddingPackId] = useState(null);
    const { addToCart } = useCart();
    const navigate = useNavigate();

    useEffect(() => {
        fetchPacks();
    }, []);

    const fetchPacks = async () => {
        try {
            setLoading(true);
            const data = await publicApi.getPacks();
            setPacks(data);
        } catch (error) {
            console.error('Error fetching packs:', error);
        } finally {
            setLoading(false);
        }
    };

    // Get image URL from publicApi
    const getImageUrl = (imagePath) => {
        return publicApi.getImageUrl(imagePath);
    };

    // Add pack to cart and navigate to cart
    const handleOrderPack = (pack) => {
        setAddingPackId(pack.id);
        
        // Create a pack item for the cart
        const packItem = {
            id: `pack-${pack.id}`,
            name: pack.name,
            price: parseFloat(pack.price),
            price_casa: parseFloat(pack.price), // Pack price is the same for all regions
            image: pack.product_images?.[0]?.image || null,
            quantity: 1,
            isPack: true,
            packId: pack.id,
            packProducts: pack.product_images || [],
            unit: 'pack'
        };
        
        // Add pack to cart
        addToCart(packItem);
        
        // Navigate to cart after short delay
        setTimeout(() => {
            setAddingPackId(null);
            navigate('/cart');
        }, 300);
    };

    if (loading) {
        return (
            <section className="top-vendors py-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <h5 className="mb-0">Pack Spécial Mariage</h5>
                    </div>
                    <div className="text-center py-5">
                        <div className="spinner-border text-main" role="status">
                            <span className="visually-hidden">Chargement...</span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!packs || packs.length === 0) {
        return null; // Don't render section if no packs
    }

    return (
        <section className="top-vendors py-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Pack Spécial Mariage</h5>
                        <Link
                            to="/shop"
                            className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                        >
                            Voir Tous Les Packs
                        </Link>
                    </div>
                </div>
                <div className="row gy-4 vendor-card-wrapper">
                    {packs.map((pack) => (
                        <div key={pack.id} className="col-xxl-3 col-lg-4 col-sm-6">
                            <div className="vendor-card vendor-card-gradient text-center px-16 pb-24">
                                <div className="">
                                    {/* Pack Logo - Use default logo */}
                                    <img
                                        src="assets/images/thumbs/vendor-logo1.png"
                                        alt={pack.name}
                                        className="vendor-card__logo m-12"
                                    />
                                    <h6 className="title mt-32">{pack.name}</h6>
                                    <span className="text-heading text-sm d-block">
                                        {pack.type || 'Pack Mariage'}
                                    </span>
                                    {pack.price && (
                                        <span className="text-main-600 fw-semibold d-block mt-4">
                                            {parseFloat(pack.price).toFixed(2)} DH
                                        </span>
                                    )}
                                    <button
                                        onClick={() => handleOrderPack(pack)}
                                        disabled={addingPackId === pack.id}
                                        className="btn btn-main-two rounded-pill py-6 px-16 text-12 mt-8"
                                    >
                                        {addingPackId === pack.id ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                                Ajout...
                                            </>
                                        ) : (
                                            'Commander'
                                        )}
                                    </button>
                                </div>
                                {/* Product Images in Pack (up to 5) */}
                                <div className="vendor-card__list mt-22 flex-center flex-wrap gap-8">
                                    {pack.product_images && pack.product_images.slice(0, 5).map((product, index) => (
                                        <div 
                                            key={product.id || index} 
                                            className="vendor-card__item bg-white rounded-circle flex-center"
                                            title={product.name}
                                            style={{
                                                width: '50px',
                                                height: '50px',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <img 
                                                src={getImageUrl(product.image)} 
                                                alt={product.name}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        </div>
                                    ))}
                                    {/* Show placeholder images if less than 5 products */}
                                    {pack.product_images && pack.product_images.length < 5 && 
                                        [...Array(5 - pack.product_images.length)].map((_, index) => (
                                            <div 
                                                key={`placeholder-${index}`} 
                                                className="vendor-card__item bg-white rounded-circle flex-center"
                                                style={{
                                                    width: '50px',
                                                    height: '50px',
                                                    backgroundColor: '#f5f5f5'
                                                }}
                                            >
                                                <img 
                                                    src={`assets/images/thumbs/vendor-img${index + 1}.png`} 
                                                    alt=""
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        opacity: 0.5
                                                    }}
                                                />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default TopVendorsOne